import { VaultFormValidationError } from "../../exceptions/VaultFormValidationError";
import type { FormValue } from "../../redux/interfaces/folder.types";

export interface VaultFormValidationErrorSummary {
  readonly fields: Record<string, string>;
  readonly description: string;
}

export function summarizeVaultFormValidationError(
  error: VaultFormValidationError,
  formValues: readonly FormValue[],
): VaultFormValidationErrorSummary {
  const labelByKey = new Map(
    formValues.map((field) => [field.key, field.label || field.key]),
  );
  const description = Object.entries(error.fields)
    .slice(0, 3)
    .map(([key, message]) => `${labelByKey.get(key) ?? key}: ${message}`)
    .join(" | ");

  return {
    fields: error.fields,
    description,
  };
}
